import { useEffect } from 'react'
import { startListening } from '@core/Store/listenerMiddleware'
import { confirmAllBets } from '@mobi/betslip/Store/Workflow/asyncActions'
import { setQualtricsBetData } from '@core/Areas/Qualtrics/qualtrics'
import { FobBetReceiptResponse } from '@mobi/betslip/types'

export const useSetQualtricsOnBetPlaced = (shouldEnable: boolean) => {
  useEffect(() => {
    if (!shouldEnable) return undefined

    const stopListener = startListening({
      actionCreator: confirmAllBets.fulfilled,
      effect: action => {
        const specialsBets = action.payload.filter(
          responseItem =>
            responseItem.receipt &&
            'specialOffers' in responseItem.receipt &&
            ((responseItem.receipt as FobBetReceiptResponse)?.specialOffers?.length ?? 0) > 0
        )
        const bonusBets = action.payload.filter(responseItem => responseItem.receipt?.bonusBet)

        const bet = specialsBets[0] || bonusBets[0]

        if (bet) {
          const isMulti = (bet.legs ?? []).length > 1
          setQualtricsBetData(
            'racing',
            bet.receipt?.bonusBet ? 'bonus' : 'special',
            bet.receipt?.bonusBet || bet.receipt?.amountPaid,
            isMulti ? 'multi' : 'single'
          )
        }
      },
    })

    return () => stopListener()
  }, [shouldEnable])
}
